import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import AppRoutes from "./app/AppRoutes";
import ErrorBoundary from "./app/ErrorBoundary";
import ScrollToTop from "./app/ScrollToTop";
import GlobalStyle from "./styles/GlobalStyle";
import theme from "./styles/theme";

/** Корневой компонент: только провайдеры и роутер. */
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <ScrollToTop />
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
